import { useContext } from 'react';
import { StoreContext } from '.';

export function StoreHook(){
    const [start,dispatch]= useContext(StoreContext)
    return [start,dispatch]
}